<template>
  <div>
    <q-form ref="editForm">
      <c-card title="기본정보" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline>
            <c-btn 
              v-show="isOld && disabled && editable" 
              :url="deleteAuthUrl"
              :isSubmit="isDeleteAuth"
              :param="data"
              mappingType="PUT"
              label="삭제" 
              icon="delete_forever" 
              auth="ENV"
              @beforeAction="deleteAuth"
              @btnCallback="deleteAuthCallback"  />
            <c-btn 
              v-show="isOld && !disabled && editable && isOwner" 
              label="삭제" 
              icon="delete_forever" 
              @btnClicked="removePlan" />
            <c-btn
              v-show="!disabled && editable"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="data"
              :mappingType="mappingType"
              label="임시저장"
              icon="save"
              @beforeAction="savePlan"
              @btnCallback="saveCallback" 
            />
            <c-btn
              v-show="isOld && !disabled && editable"
              :url="updateUrl"
              :isSubmit="isComplete"
              :param="data"
              mappingType="PUT"
              label="완료"
              icon="check"
              @beforeAction="completePlan"
              @btnCallback="completeCallback" 
            />
            <c-btn
              v-show="isOld && disabled && editable && isOwner"
              :url="updateUrl"
              :isSubmit="isComplete2"
              :param="data"
              mappingType="PUT"
              label="완료취소"
              icon="check"
              @beforeAction="completePlan2"
              @btnCallback="completeCallback2" 
            />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-datepicker
              :required="true"
              :editable="editable"
              :disabled="disabled"
              label="순회일"
              name="patrolDate"
              v-model="data.patrolDate"
              @datachange="datachangeDate"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              :required="true"
              :editable="editable"
              :disabled="disabled"
              label="순회명"
              name="patrolName"
              v-model="data.patrolName">
            </c-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-dept
              :required="true"
              :editable="editable"
              :disabled="disabled"
              label="점검주관부서"
              name="deptCd"
              v-model="data.deptCd"
              @setDeptName="(deptName) => { data.deptName = deptName }"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-plant 
              :required="true"
              :disabled="disabled || isOld"
              :editable="editable" 
              type="edit" 
              name="plantCd" 
              v-model="data.plantCd"
              @datachange="datachange"/>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <c-multi-field
              :required="true"
              :editable="editable"
              :data="data"
              :disabled="disabled"
              label="점검자"
              type="user"
              name="checkUserId"
              v-model="data.checkUserId">
            </c-multi-field>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-select
              type="edit"
              :disabled="disabled"
              :comboItems="lineItems"
              :editable="editable"
              itemText="lineCd"
              itemValue="lineId"
              label="라인"
              name="lineId"
              v-model="data.lineId">
            </c-select>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-select
              type="edit"
              :disabled="disabled"
              :comboItems="placeItems"
              :editable="editable"
              itemText="placeName"
              itemValue="placeId"
              label="장소"
              name="placeId"
              v-model="data.placeId">
            </c-select>
          </div>
        </template>
      </c-card>
      <c-table
        ref="table"
        title="점검항목 목록"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="data.resultList"
        :filtering="false"
        :columnSetting="false"
        :usePaging="false"
        noDataLabel="점검항목이 없습니다. 점검항목 메뉴에서 사업장별로 항목을 추가하세요."
        :hideBottom="true"
        :editable="editable&&!disabled"
        rowKey="envPatrolResultId"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn 
              v-if="isOld" 
              label="개선 전체보기" 
              icon="help" 
              @btnClicked="imprDetailPop" />
          </q-btn-group>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="props.row['sopImprovementIds'] && props.row['ibmStepNames']">
            <q-chip
              v-for="(item, index) in $comm.ibmTagItems(props.row, colorItems)"
              :key="index"
              :color="item.color"
              :clickable="true"
              text-color="white"
              style="margin-bottom:4px !important;"
              @click="linkClick(item, props.row)">
              {{item.title}}
              <c-assess-tooltip 
                :ibmTooltip="item.ibmTooltip"
                :ibmClassCd="item.ibmClassCd"
              />
            </q-chip>
          </template>
          <div v-if="data.envPatrolId">
            <q-btn-group outline class="ColumInnerBtnGroup">
              <q-btn
                v-if="editable && !disabled"
                icon="add"
                color="red-6"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '1')">
                <q-tooltip>
                  개선요청등록
                </q-tooltip>
              </q-btn>
              <q-btn
                v-if="editable && !disabled"
                icon="add"
                color="light-blue"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '2')">
                <q-tooltip>
                  즉시조치등록
                </q-tooltip>
              </q-btn>
            </q-btn-group>
          </div>
        </template>
        <template slot="suffixTitle">
          <font class="text-negative" style="font-size:0.8em;font-weight:300;">
            O : 양호  X : 불량  △ : 요정비
          </font>
        </template>
      </c-table>
      <c-table
        ref="gridImpr"
        title="항목외 개선 목록"
        :columns="gridImpr.columns"
        :data="gridImpr.data"
        :usePaging="false"
        :filtering="false"
        :columnSetting="false"
        @linkClick="linkClick2"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable && popupParam.envPatrolId" label="개선요청" :showLoading="false"  icon="add" @btnClicked="addImpr" />
            <c-btn v-if="editable && popupParam.envPatrolId" label="즉시조치" :showLoading="false"  icon="add" @btnClicked="addiimImpr" />
          </q-btn-group>
        </template>
      </c-table>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import { uid } from "quasar";
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'env-patrol-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        envPatrolId: '',
      }),
    },
  },
  data() {
    return {
      editable: false,
      data: {
        envPatrolId: '',
        plantCd: '',
        patrolName: '',
        patrolDate: '',
        deptCd: '',
        deptName: '',
        checkUserId: '',
        patrolResultSummary: '',
        patrolStepCd: '',
        placeId: null,
        lineId: null,
        resultList: [],
        oriUserId: '',
      },
      colorItems: [],
      grid: {
        columns: [
        ],
        data: [],
        height: '550px'
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: true,
        top: '',
        param: {},
        closeCallback: null,
      },
      updateMode: false,
      getUrl: '',
      saveUrl: 'transactionConfig.env.patrol.insert.url',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      deleteAuthUrl: '',
      isComplete: false,
      isComplete2: false,
      isSave: false,
      isDeleteAuth: false,
      mappingType: 'POST',
      lineItems: [],
      placeItems: [],
      gridImpr: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'ibmClassName',
            field: 'ibmClassName',
            label: '구분',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'actionDeptName',
            field: 'actionDeptName',
            label: '조치부서',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'ibmTitle',
            field: 'ibmTitle',
            label: '제목',
            align: 'left',
            style: 'width:300px',
            sortable: false,
            type: 'link',
          },
          {
            name: 'actionContents',
            field: 'actionContents',
            label: '조치내용',
            align: 'left',
            style: 'width:400px',
            sortable: false,
          },
          {
            name: 'actionCompleteDate',
            field: 'actionCompleteDate',
            label: '조치완료일',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    isOld() {
      return Boolean(this.popupParam.envPatrolId)
    },
    isOwner() {
      if (this.data.oriUserId === this.$store.getters.user.userId) {
        return true;
      } else if (this.data.checkUserId !== null) {
        if (this.data.checkUserId.indexOf(this.$store.getters.user.userId) > -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    disabled() {
      return this.data.patrolStepCd === 'Y';
    },
  },
  watch: {
    'data.plantCd'() {
      this.setData();
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
        this.colorItems = _result
      });

      this.getUrl = selectConfig.env.patrol.get.url;
      this.insertUrl = transactionConfig.env.patrol.insert.url;
      this.updateUrl = transactionConfig.env.patrol.update.url;
      this.deleteUrl = transactionConfig.env.patrol.delete.url;
      this.deleteAuthUrl = transactionConfig.env.patrol.delete.auth.url;
      this.impListUrl = selectConfig.sop.ibm.improve.others.url;
      this.setHeader();
      this.getDetail();
    },
    getImpList() { // 항목외 개선목록
      if (this.popupParam.envPatrolId) {
        this.$http.url = this.impListUrl;
        this.$http.param = {ibmTaskTypeCd: 'ITT0000135', relationTableKey: this.popupParam.envPatrolId};
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.gridImpr.data = _result.data;
        },);
      }
    },
    setHeader() {
      // EPR0000001 : O
      this.$comm.getComboItems('ENV_PATROL_RESULT_CD').then(_result => {
        this.grid.columns = [
          {
            name: 'patrolItemName',
            field: 'patrolItemName',
            label: '점검항목',
            style: 'width:45%',
            align: 'left',
            sortable: false,
          },
          {
            name: 'patrolResultCd',
            field: 'patrolResultCd',
            align: 'center',
            label: '점검결과',
            type: 'select',
            isChip: true,
            none: true,
            style: 'width:15%',
            comboItems: _result,
            sortable: false,
          },
          {
            name: 'impr',
            field: 'impr',
            label: '개선진행',
            align: 'center',
            child: [
              {
                name: 'customCol',
                field: 'customCol',
                label: '개선번호/개선진행상태',
                align: 'center',
                style: 'width:40%',
                type: 'custom',
                sortable: false
              },
            ]
          },
        ]
      })
    },
    setData() {
      this.$http.url = selectConfig.mdm.line.list.url;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.data.plantCd,
        useFlag: 'Y',
      }
      this.$http.request((_result) => {
        this.lineItems = _result.data;
      },);
      this.$http.url = selectConfig.mdm.place.list.url;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.data.plantCd,
        useFlag: 'Y',
      }
      this.$http.request((_result) => {
        this.placeItems = _result.data;
      },);
    },
    getDetail() {
      if (this.popupParam.envPatrolId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.envPatrolId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data = this.$_.clone(_result.data);
        },);
      } else {
        this.datachange();
        this.data.patrolDate = this.$comm.getToday();
        this.data.patrolName = this.$comm.getToday() + ' 순회점검';
        this.data.checkUserId = this.$store.getters.user.userId;
      }
    },
    savePlan() {
      if (this.popupParam.envPatrolId) {
        this.mappingType = 'PUT';
        this.saveUrl = this.updateUrl;
      } else {
        this.mappingType = 'POST';
        this.saveUrl = this.insertUrl;
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.envPatrolId = result.data
      this.getDetail();
    },
    completePlan() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '점검 완료 처리하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              this.data.patrolStepCd = 'Y';

              this.isComplete = !this.isComplete;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('transInfo', this.popupParam.envPatrolId)
    },
    completePlan2() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '점검 완료를 취소 처리하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              this.data.patrolStepCd = 'N';

              this.isComplete2 = !this.isComplete2;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback2() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('transInfo', this.popupParam.envPatrolId)
    },
    removePlan() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제시 관련된 개선요청/조치내역도 삭제됩니다.\n\r 그래도 삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.envPatrolId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup')
          })
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    datachange() {
      if (!this.data.plantCd) return;
      
      this.data.lineId = null;
      this.data.placeId = null;
      this.data.resultList = [];
      this.$http.url = selectConfig.env.patrol.item.list.url;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.data.plantCd,
        useFlag: 'Y',
      };
      this.$http.request((_result) => {
        if (_result.data) {
          this.$_.forEach(_result.data, _item => {
            this.data.resultList.push({
              envPatrolId: this.data.envPatrolId,
              envPatrolResultId: uid(),
              patrolItemName: _item.patrolItemName,
              sortOrder: _item.sortOrder,
              patrolResultCd: 'EPR0000005',
              editFlag: 'C',
            })
          })
        }
      },);
    },
    datachangeDate() {
      this.data.patrolName = this.data.patrolDate + ' 순회점검'
    },
    innerBtnClicked(col, props, btn) {
      this.requestImprRow = props.row
      if (btn === '1') {
        this.popupOptions.title = '개선 요청';
        this.popupOptions.param = {
          requestContents: this.data.patrolName + ' / ' + props.row.patrolItemName,
          relationTableKey: props.row.envPatrolResultId,
          ibmTaskTypeCd: 'ITT0000135'
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.isFull = false;
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          requestContents: this.data.patrolName + ' / ' + props.row.patrolItemName,
          relationTableKey: props.row.envPatrolResultId,
          ibmTaskTypeCd: 'ITT0000135'
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmediate.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.isFull = false;
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      }
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.getDetail();
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
      }
    },
    linkClick(data, row, num) {
      this.requestImprRow = row
      this.imprData = data;

      if (data.ibmClassCd === 'IC00000001') {
        this.popupOptions.title = '개선';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.isFull = false;
        this.popupOptions.visible = true;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.isFull = false;
        this.popupOptions.visible = true;
      }
      if (num == '2') {
        this.popupOptions.closeCallback = this.closeAddImprPopup2;
      } else {
        this.popupOptions.closeCallback = this.closeImprPopup;
      }
    },
    linkClick2(row){
      this.linkClick(row, row, '2');
    },
    closeImprPopup(result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
        let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
        if (splitId && splitId.length > 0) {
          let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
          splitStep[idIndex] = result.col1.ibmStepName;
          this.requestImprRow.ibmStepNames = splitStep.toString();
        }
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
      }
      this.getDetail();
    },
    addImpr() {
      this.popupOptions.title = '개선 요청';
      this.popupOptions.param = {
        requestContents: this.data.patrolName,
        relationTableKey: this.popupParam.envPatrolId,
        ibmTaskTypeCd: 'ITT0000135',
      };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup2;
    },
    addiimImpr() {
      this.popupOptions.title = '즉시조치';
      this.popupOptions.param = {
        requestContents: this.data.patrolName,
        relationTableKey: this.popupParam.envPatrolId,
        ibmTaskTypeCd: 'ITT0000135',
      };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmediate.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup2;
    },
    closeAddImprPopup2() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getImpList();
    },
    imprDetailPop() {
      this.popupOptions.title = '개선 요청';
      this.popupOptions.param = {
        parentKey: this.popupParam.envPatrolId,
        ibmTaskTypeCd: 'ITT0000135',
      };
      this.popupOptions.target = () => import(`${'@/pages/common/ibm/imprTabDetail.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup;
    },  
    deleteAuth() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?\n(※ 연결된 [개선] 또한 같이 삭제됩니다.)',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.isDeleteAuth = !this.isDeleteAuth;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    deleteAuthCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('closePopup')
    },
  }
};
</script>